import {
  SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT,
  SYS_SPACE_FIXED_300,
} from '@oneaudi/unified-web-common';
import styled from 'styled-components';

const CARD_MIN_WIDTH = 285;
const CARD_MAX_WIDTH = 332;
const CARD_GAP = parseInt(SYS_SPACE_FIXED_300, 10);
// how to use a css var here?
const PAGE_MARGIN = {
  s: 56,
  m: 80,
  l: 120,
};

interface FoldoutProps {
  actualHeight?: number;
}

export const Foldout = styled.div<FoldoutProps>`
  height: ${(props) => (props.actualHeight ? `${props.actualHeight}px` : '0')};
  overflow: hidden;
  ${process.env.IS_LEGACY &&
  `
    background-color: ${SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT};
  `}
  padding: ${(props) =>
    props.actualHeight ? `${props.theme.spacing.fixed350} var(--page-margin)` : '0'};
  @media (min-width: ${(props) => props.theme.breakpoints.md}px) {
    transition-property: height;
    transition-duration: 0.2s;
    transition-timing-function: ease-in-out;
  }
  z-index: 1;
`;

export const StyledCarlineGrid = styled.div<{ isActive: boolean }>`
  display: ${(props) => (props.isActive ? 'grid' : 'none')};
  grid-template-columns: repeat(auto-fill, minmax(${CARD_MIN_WIDTH}px, ${CARD_MAX_WIDTH}px));

  grid-gap: ${CARD_GAP}px;

  @media (min-width: ${CARD_MIN_WIDTH * 2 + CARD_GAP + PAGE_MARGIN.s}px) {
    grid-template-columns: repeat(2, minmax(${CARD_MIN_WIDTH}px, ${CARD_MAX_WIDTH}px));
  }

  @media (min-width: ${CARD_MIN_WIDTH * 3 + CARD_GAP * 2 + PAGE_MARGIN.m}px) {
    grid-template-columns: repeat(3, minmax(${CARD_MIN_WIDTH}px, ${CARD_MAX_WIDTH}px));
  }

  @media (min-width: ${CARD_MIN_WIDTH * 4 + CARD_GAP * 3 + PAGE_MARGIN.l}px) {
    grid-template-columns: repeat(4, minmax(${CARD_MIN_WIDTH}px, ${CARD_MAX_WIDTH}px));
  }
  padding-bottom: ${({ theme }) => theme.spacing.fixed150};
`;
